module.exports = __webpack_public_path__ + "static/scale-model-of-athica-athens-institute-in-athens-georgia-915751aae350d5cf9302c88847bfd0d6.png";